import Flex from '@commons/containers/Flex';
import PageBuilder from '@commons/pagebuilder';
import type { DrupalInsightsView } from '@commons/pagebuilder/views/Insights';

/**
 * By member display of the insights view.
 *
 * Renders a set of insights based on the member contextual id.
 */

const ByMemberDisplay = ({ content }: DrupalInsightsView) => {
  return (
    <Flex gap="xs" direction="column">
      {content.map(PageBuilder.renderNode)}
    </Flex>
  );
};

export default ByMemberDisplay;
